import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { Path } from 'app/shared/path';
import { TranslateService } from '@ngx-translate/core';

@Component({
   selector: 'app-monthly-summary',
   templateUrl: 'monthly.component.html',
   styleUrls: ['monthly.component.css']
})
export class MonthlySummaryComponent implements OnInit {
   yearList: any;
   select_year: string;
   monthList: any;
   tin: any;
   type: any;
   loading = true;
   constructor(public dialogRef: MatDialogRef<MonthlySummaryComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any, private service: IdexService, private translate: TranslateService) { }

   ngOnInit(): void {
      this.yearList = this.data.years;
      if (this.yearList && this.yearList.length > 0) {
         this.select_year = this.yearList[0].toString();
      }
      this.tin = this.data.tin;
      this.type = this.data.type;
      this.listReport();
   }

   openReport(month: any, value: any) {
      if (this.select_year && value > 0) {
         localStorage.setItem('serviceUrl', this.service.url);
         const url = `${Path.getAppUrl()}tax-report.html?tin=${this.data.tin}&type=${this.data.type}`
                   + `&year=${this.select_year}&month=${month}&lang=${this.translate.currentLang}`;
         window.open(url, '_blank');
      }
   }

   listReport() {
      this.service.get(`/report/${this.tin}/${this.type}/${this.select_year}`)
         .subscribe(data => {
            this.monthList = data.month;
            this.loading = false;
         });
   }

   yearChange() {
      this.loading = true;
      this.monthList = null;
      this.listReport();
   }
}
